import React, { useState } from 'react'
import { useResetPasswordMutation, useVerifyPasswordMutation } from '../../redux/API/registerApi'
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
const [data, setData] = useState({
  email: '',
  password: '',
  confirmPassword: '',
})

 const [otp, setOtp] = useState(new Array(6).fill(""));
const [error, setError] = useState("")
const [show, setShow] = useState(false)
const [loader, setLoader] = useState(false)
const [postData] = useResetPasswordMutation()
const [verifyOtp] = useVerifyPasswordMutation()
const navigate = useNavigate()
const handleChange = (e) => {
  const {name, value} = e.target
  setData({...data, [name]: value})
}

  // Handle OTP feilds Changes
  const handleOtpChange = (e, index) => {
  setOtp([...otp.map((d, idx) => (idx === index ? e.value : d))]);

    if (e.nextSibling) {
      e.nextSibling.focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && e.target.previousSibling) {
      e.target.previousSibling.focus();
    }
  };

const handleSubmit = (e) => {
  e.preventDefault()
  if (data.email === ""){
    setError("Please Enter Your Email")
    setTimeout(() => {
      setError("")
    }, 3500);
    return;
  }
  setLoader(true)
    postData({email: data.email}).then((res) => {
      if(res?.data?.success){
        setLoader(false)
         setShow(true)
      }
      else{
        setError("Invalid Email")
      }
      
    }).catch((err) =>{
      console.log(err);
      
    })
  
}



const handlepassword = (e) => {
  e.preventDefault()
  if (data.password === "" || otp === ""){
    setError("Please Enter OTP and Password")
    setTimeout(() => {
      setError("")
    }, 3500);
    return;
  }
  if (data.password !== data.confirmPassword){
    setError("Password and Confirm Password Should be Same")
    setTimeout(() => {
      setError("")
    }, 3500);
    return;
  }
    verifyOtp({email: data.email, otp: otp.join(""), newpassword: data.password}).then((res) => {
      if(res?.data?.success){
        navigate("/login")
      }
      else{
        setError("Invalid OTP")
      }
      
    }).catch((err) =>{
      console.log(err);
    })
  
}

  return (
    <>
    <div className="login">
      {
        !show ? (
        <div className="login-container position-relative">
        <div className="heading mt-2">Reset Password</div>
        <p className="text-danger text-center mb-1">{error}</p>
        <form className="d-flex flex-column mt-4" onSubmit={handleSubmit}>
        <label htmlFor="" className='mb-1'>Enter Email</label>
          <input  className="input border px-2 py-2" type="email" name="email" id="email" placeholder="Enter Email" value={data.email}  
          onChange={handleChange}/>
         <button type='submit' className='mt-3 next_btn border-0 rounded-pill text-white py-1'>
          {
            !loader ? (
              <span>Next</span>
            )
            : 
            (
         <div class="dot-spinner mx-auto">
            <div class="dot-spinner__dot"></div>
            <div class="dot-spinner__dot"></div>
            <div class="dot-spinner__dot"></div>
            <div class="dot-spinner__dot"></div>
            <div class="dot-spinner__dot"></div>
            <div class="dot-spinner__dot"></div>
            <div class="dot-spinner__dot"></div>
            <div class="dot-spinner__dot"></div>
       </div>  
            )
          }
         </button>
        </form>
      </div>
      )
      :  
      (
        <div className="login-container position-relative shadow" style={{maxWidth: "400px"}}>
        <div className="heading mt-2">Reset Password</div>
        <p className="text-danger text-center mb-1">{error}</p>
        <form className="" onSubmit={handlepassword}>
       <div className='w-100 mb-3'>
        <label htmlFor="" className='mb-1'>Enter OTP</label>
       <div className="inputs text-center d-flex justify-content-between w-100">
                  {otp.map((data, index) => {
                    return (
                      <input
                        type="text"
                        maxLength="1"
                        onChange={(e) => handleOtpChange(e.target, index)}
                        onKeyDown={(e) => handleBackspace(e, index)}
                        key={index}
                        value={data}
                        onFocus={(e) => e.target.select()}
                        style={{width: "50px"}}
                        className='border py-1 text-center'
                      />
                    );
                  })}
                </div>
       </div>
     <div className='mb-3'>
     <label htmlFor="" className='mb-1'>Enter New Password</label>
          <input  className="input border px-2 py-2 w-100"  type="password" name="password" id="password" value={data.password}  
          onChange={handleChange} placeholder='New Password'/>
     </div>
     <div>
     <label htmlFor="" className='mb-1'>Enter Confirm Password</label>
          <input  className="input border px-2 py-2 w-100"  type="password" name="confirmPassword" id="confirmpassword" value={data.confirmPassword}  
          onChange={handleChange} placeholder=' Confirm Password'/>
     </div>
         
     <button type='submit' className='mt-3 next_btn border-0 rounded-pill w-100 text-white py-1'>Submit</button>
        </form>
      </div>
        )
      }
      </div>
    
    </>
  )
}

export default ForgotPassword